/** @format */

import React from 'react';
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  CardActionArea,
} from '@mui/material';
import { useStyles } from './style';
import jMoment from 'moment-jalaali';
import createToast from 'components/Toast/Toast';
import { ButtonLoading, ConfirmDialog } from 'components';
import { deleteDocService } from '../../services';
import useCustomHook from './hooks';

require('moment/locale/fa');

export default function DocItem({ file, refreshList, disableDelete = false, docTypes = [] }) {
  // -- STATES --//

  const {
    deleting,
    setDeleting,
    confirmDeleteModal,
    setConfirmDeleteModal,
    thumbnailIsLoaded,
    setThumbnailIsLoaded,
  } = useCustomHook();

  // --HOOKS--//
  const classes = useStyles();

  // --API--//
  const openFile = () => {
    if (file?.hash) {
      window.open(`https://podspace.pod.ir/api/files/${file.hash}`, '_blank');
    } else {
      createToast('خطا', 'خطایی در مشاهده سند رخ داده', 'danger');
    }
  };

  const deleteFile = async () => {
    try {
      if (!file?.hash) return;
      setDeleting(true);
      const files = {
        fileHashes: [file?.hash],
        folderHashes: [],
      };
      await deleteDocService(files);
      setDeleting(false);
      createToast('موفق', 'سند با موفقیت حذف شد', 'success');

      refreshList();
    } catch (error) {
      setDeleting(false);
    }
  };

  // --OTHER FUNCTIONS--//
  const handleRemoveAvatar = () => {
    deleteFile().then((_) => setConfirmDeleteModal(false));
  };

  const getThumbnail = () => {
    return `https://podspace.pod.ir/nzh/drive/getThumbnail/?hash=${file?.hash}`;
  };

  const getDocTypeText = (docType) => {
    return docTypes.find((doc) => doc.value === docType)?.label ?? null;
  };

  return (
    <Grid item xs={12} sm={6} lg={4} xl={3}>
      <ConfirmDialog
        open={confirmDeleteModal}
        onClose={() => setConfirmDeleteModal(false)}
        onConfirm={handleRemoveAvatar}
        title="تایید حذف سند"
        content="آیا از حذف سند انتخاب شده اطمینان دارید؟"
        confirmButtonText="حذف سند"
        cancelButtonProps="انصراف"
      />

      <Card elevation={0} variant="outlined" xs={12} className={classes.root} container>
        <CardActionArea onClick={openFile}>
          <CardMedia>
            <Grid container justifyContent="center" alignItems="center" className={classes.fileFormatCard}>
              {file?.thumbnail === 1 ? (
                <img
                  src={getThumbnail()}
                  alt="پیش‌نمایش سند"
                  onLoad={() => setThumbnailIsLoaded(true)}
                  style={{ display: thumbnailIsLoaded ? 'block' : 'none' }}
                />
              ) : null}
              {file?.thumbnail === -1 || !thumbnailIsLoaded ? (
                <Typography variant="h3" component="div" style={{ direction: 'ltr' }}>
                  {`.${file?.extension}`}
                </Typography>
              ) : null}
            </Grid>
          </CardMedia>
        </CardActionArea>

        <CardContent className={classes.content}>
          <Typography
            className={classes.fileName}
            onClick={openFile}
            variant="h5"
            color="textPrimary"
            component="div"
          >
            {file?.documentType ? getDocTypeText(file?.documentType) ?? file?.name : file?.name}
          </Typography>
          <Typography className={classes.date} variant="h6" color="textSecondary" component="div">
            {jMoment(file?.created).format('dddd, jD jMMMM jYYYY')}
          </Typography>
          <Grid container item className={classes.buttonGroup}>
            <Button onClick={openFile} className={classes.viewButton} color="primary" size="large">
              مشاهده
            </Button>
            <ButtonLoading
              onClick={() => (!disableDelete ? setConfirmDeleteModal(true) : null)}
              className={classes.deleteButton}
              color="primary"
              loading={deleting}
              size="large"
              disabled={disableDelete}
              name={deleting ? 'در حال حذف...' : 'حذف'}
            />
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}
